<template>
  <div>
    <div class="contenant" v-if="situation && situation.media">
      <div class="video-blur1" v-bind:style="{ width: 50 + '%' }">
        <video id="video" preload="auto">
          <source id="image" class="videoSrc" :src="situation.media.filename" type="video/mp4" />
        </video>
      </div>

      <div class="video-blur2" v-bind:style="{ width: 50 + '%' }">
        <video id="video" preload="auto">
          <source id="image" class="videoSrc" :src="situation.media.filename" type="video/mp4" />
        </video>
      </div>

      <div id="filtre" class="left" v-bind:style="{ width: width + '%' }">
        <video id="video" class="video1" preload="auto">
          <source id="image" class="videoSrc" :src="situation.media.filename" type="video/mp4" />
        </video>
      </div>
      <div id="filtre" class="right" v-bind:style="{ width: 100 - width + '%' }">
        <video id="video" class="video2" preload="auto">
          <source id="image" class="videoSrc" :src="situation.media.filename" type="video/mp4" />
        </video>
      </div>
      <div class="glass"></div>
    </div>
    <figure v-if="showPlayButton">
      <button name="play" v-on:click="playVideo"></button>
    </figure>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      width: '50',
      showPlayButton: true,
    };
  },
  mounted() {
    const video = document.querySelector('#video');
    const glassMask = document.querySelector('.glass');

    if (video) {
      video.onended = () => {
        this.hideCursor();
      };
    }

    //Observe resize of #video to set his height and width to the glass mask
    const myObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        glassMask.style.width = entry.contentRect.width + 'px';
        glassMask.style.height = entry.contentRect.height + 'px';
      });
    });

    myObserver.observe(video);
  },
  computed: {
    situation() {
      return this.$store.getters.getSituationById(this.$route.params.idSituation)[0];
    },
  },
  methods: {
    playVideo: function() {
      const videos = document.querySelectorAll('video');
      if (videos) {
        videos.forEach(video => {
          video.play();
        });
      }
      this.showPlayButton = false;
    },
    hideCursor: function() {
      this.showPlayButton = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contenant {
  overflow: hidden;
  position: relative;
  width: fit-content;
  margin: auto;
}
.video-blur1 {
  filter: blur(20px);
  overflow: hidden;
  width: 50%;
}
.video-blur2 {
  position: absolute;
  overflow: hidden;
  width: 50%;
  right: 0;
  top: 0;
  filter: blur(20px);
}
.video-blur2 video {
  float: right;
}
.glass {
  -webkit-mask-image: url(/glass.svg);
  mask-image: url(/glass.svg);
  -webkit-mask-size: auto 100%;
  mask-size: auto 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* default height */
  height: 800px;
  opacity: 0.85;
  background-color: black;
}
.video1 {
  -webkit-mask-size: auto 100%;
  mask-size: auto 100%;
}
.video2 {
  -webkit-mask-size: auto 100%;
  mask-size: auto 100%;
  position: absolute;
  top: 0;
  right: 0;
}
#filtre {
  width: 50%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  opacity: 1;
  border-right: 2px solid black;
}
#filtre.right {
  right: 0;
  width: 50%;
  border-left: 1px black solid;
}
#filtre.left {
  left: 0;
  width: 50%;
  border-right: 1px black solid;
}

video {
  display: block;
  margin: auto;
  object-fit: cover;
}
video:before {
  content: '';
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #000000;
  opacity: 0.7;
}
.videoSrc {
  position: relative;
}

figure {
  width: 200px;
  height: 200px;
  top: 50%;
  left: 50%;
  margin-top: -100px;
  margin-left: -100px;
  overflow: hidden;
  position: absolute;
  z-index: 100;
  transition: all 0.2s ease-in-out;
}
figure:hover {
  transform: scale(1.1);
}
figure button[name='play'] {
  width: 200px;
  height: 200px;
  background-color: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 100%;
  margin: auto;
  cursor: pointer;
}
figure button[name='play']:focus {
  outline: 0;
  border: none;
  box-shadow: none;
}

figure button[name='play']::after {
  content: '';
  display: inline-block;
  position: relative;
  top: 1px;
  left: 3px;
  border-style: solid;
  border-width: 50px 0 50px 60px;
  border-color: transparent transparent transparent white;
}

@media screen and (min-width: 1440px) {
  video {
    height: 87vh;
  }
}

@media screen and (max-width: 1280px) {
  video {
    height: 64vh;
  }
}

@media screen and (max-width: 1280px) {
  video {
    height: 64vh;
  }
}
</style>
